import Vue from "vue"

const INITIAL_CHANGE_ORDER = {
  number: ''
}

export const changeOrderStore = {
  state: {
    // TODO: Нужно из-за DocumentForm
    changeOrder: {
      number: ''
    },
    changeOrders: [],
  },
  mutations: {
    SET_CHANGE_ORDER_PROPERTY(state, { key, value }) {
      Vue.set(state.changeOrder, key, value)
    },
    SET_CHANGE_ORDER(state, changeOrder) {
      // TODO: мож Vue.set заменить на this._vm.$set?
      Vue.set(state, 'changeOrder', changeOrder)
    },
    SET_CHANGE_ORDERS(state, changeOrders) {
      Vue.set(state, 'changeOrders', changeOrders)
    },
    SET_INITIAL_CHANGE_ORDER(state) {
      Vue.set(state, 'changeOrder', INITIAL_CHANGE_ORDER)
    }
  },
  actions: {
    deleteChangeOrder({ commit }, changeOrderId) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(`api/v1/change_orders/${changeOrderId}`).then(data => {
          if (data.ok) {
            resolve(data)
          }
        })
      })
    }
  },
  getters: {
    getChangeOrderChangeDate(state) {
      return Vue.prototype
        .$dayjs(state.changeOrder.change_date)
        .format('DD.MM.YYYY')
    },
    getChangeOrderDeletedAt: (state) => (index) => {
      return Vue.prototype
        .$dayjs(state.changeOrders[index].deleted_at)
        .format('DD.MM.YYYY H:mm')
    }
  }
}